export const uid = () => new Date().getTime().toString(16) + Math.random().toString(16).substring(2) + '0'.repeat(16);

export const guid = (salt = '4000-8') => {
  const uniqId = uid();
  const firstPart = uniqId.substr(0, 8);
  const secondPart = uniqId.substr(8, 4);
  const thirdPart = uniqId.substr(12, 3);
  const lastPart = uniqId.substr(15, 12);
  return [firstPart, secondPart, salt, thirdPart, lastPart].join('-');
};
